import { STORAGE_KEY } from '../config';

const isShown = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

const markAsShown = (): void => {
  try {
    localStorage.setItem(STORAGE_KEY, 'true');
  } catch {
    // Silently ignore storage errors
  }
};

const reset = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Silently ignore storage errors
  }
};

export { isShown, markAsShown, reset };
